import React from 'react';
import {
  ButtonBase, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: 'center',
    fontSize: 18,
  },
  content: {
  },
  contentText: {
    color: 'black',
    fontSize: 16,
  },
  hr: {
    borderTopColor: '#979797',
    marginBottom: 0,
  },
  button: {
    color: 'black',
    fontSize: 16,
    fontWeight: 'bold',
    width: '100%',
    '&:hover': {
      opacity: 0.5,
    },
  },
  footer: {
    paddingBottom: theme.spacing(2),
  },
}));

export default ({
  isOpen,
  onCancelButtonClick,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      keepMounted
      onClose={onCancelButtonClick}
    >
      <DialogTitle className={classes.title}>您已完成優惠券購買</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.contentText}>
          記得到「我的優惠券」設定為「最優先使用」，或在結帳時「選取優惠券」，才會完成優惠折抵喔！
        </DialogContentText>
        <hr className={classes.hr} />
      </DialogContent>
      <DialogActions className={classes.footer}>
        <ButtonBase
          className={classes.button}
          onClick={onCancelButtonClick}
        >
          我知道了
        </ButtonBase>
      </DialogActions>
    </Dialog>
  );
};
